import React from 'react';

import Icon from 'components/generic/Icon.component';

import CN from './BackButton.module.scss';

const BackButton = ({ onClick }) => (
  <div data-bem="BackButton" className={CN.icon} role="button" onClick={onClick} tabIndex={0}>
    <Icon variant="arrowRight" variantInvertDark width="lg" />
  </div>
);

export default BackButton;
